
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  setup (): unknown {
    const store = useStore()
    const toast = computed(() => store.state.toast)

    return {
      show: computed(() => toast.value !== null),
      toast
    }
  }
}
